/**
 *  Copyright (c) 2023-present The TVM Engineering Authors.
 */

export function getDateTime(date) {
  return new Date(date).toLocaleString();
}

export function getFullDate(date) {
  const dateInfo = new Date(date);
  const day = dateInfo.getDate();
  const month = dateInfo.getMonth() + 1;
  const year = dateInfo.getFullYear();
  return `${day}/${month}/${year}`;
}